export enum SessionStorageFields {
  MSAL_SILENT_ATTEMPT = 'od.msal.silent_attempt',
  MSAL_REDIRECT_FAILED = 'od.msal.redirect_failed',
  MSAL_REDIRECT_BOOT_ATTEMPTS = 'od.msal.redirect_boot_attempts',
  MSAL_RETURN_URL = 'od.msal.return_url',
}
